if (!customElements.get('pp-quote-page')) {
  class PPQuotePage extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      const params = new URLSearchParams(window.location.search);
      const sourceTitle = params.get('service') || params.get('produit') || params.get('product');
      const sourceUrl = params.get('source') || params.get('source_url');
      const universe = params.get('univers');
      const intent = params.get('parcours');

      if (sourceTitle) this.setSource(sourceTitle, sourceUrl);
      if (universe) this.setUniverse(universe);

      const success = this.querySelector('[data-pp-form-success]');
      const errors = this.querySelector('.ppds__form-errors');
      if (success) requestAnimationFrame(() => success.focus());
      if (errors) requestAnimationFrame(() => errors.focus());

      if (intent === 'etude' || intent === 'devis') {
        requestAnimationFrame(() => this.setIntent(intent));
      }
    }

    setSource(title, url) {
      const card = this.querySelector('[data-pp-source-card]');
      const titleNode = this.querySelector('[data-pp-source-title]');
      const titleInput = this.querySelector('[data-pp-source-input]');
      const urlInput = this.querySelector('[data-pp-source-url-input]');
      const link = this.querySelector('[data-pp-source-link]');

      if (titleNode) titleNode.textContent = title;
      if (titleInput) titleInput.value = title;

      if (url && url.startsWith('/')) {
        if (urlInput) urlInput.value = url;
        if (link) {
          link.href = url;
          link.hidden = false;
        }
      }

      if (card) card.hidden = false;
    }

    setUniverse(universe) {
      const select = this.querySelector('[data-pp-universe-select]');
      if (!select) return;

      const values = {
        textile: 'Textile personnalisé',
        photo: 'Photo et art',
        '3d': 'Prototypage ou impression 3D',
        stickers: 'Stickers et découpe',
        signaletique: 'Vitrines, signalétique ou marquage',
        skins: 'Skins et covering',
        pro: 'Solution professionnelle'
      };

      if (values[universe]) select.value = values[universe];
    }

    setIntent(intent) {
      const radio = this.querySelector(`[data-pp-intent-radio="${intent}"]`);
      if (!radio) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  customElements.define('pp-quote-page', PPQuotePage);
}
